import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { arrayOf, string, shape, func, bool } from 'prop-types';

import { treatmentCategoriesActions } from '~/api';

import { Section } from '../section';
import { TreatmentCategoryList } from '../treatment-category-list';

import styles from './TreatmentCategoriesSection.scss';
import { envConfigSelectors } from '~/components';

export class TreatmentCategoriesSection extends PureComponent {
  componentDidMount() {
    const { dispatchLoadTreatmentCategories } = this.props;

    dispatchLoadTreatmentCategories();
  }

  render() {
    const { title, description, treatmentCategories, isNewBrandPageFeatureEnabled } = this.props;

    return (
      !!treatmentCategories.length && (
        <Section className={styles.TreatmentCategoriesSection}>
          <Section.Title>{title}</Section.Title>
          <Section.Description>{description}</Section.Description>
          <TreatmentCategoryList
            treatmentCategories={treatmentCategories}
            isNewBrandPageFeatureEnabled={isNewBrandPageFeatureEnabled}
          />
        </Section>
      )
    );
  }
}

export const mapStateToProps = (state) => {
  const { treatmentCategories } = state;
  return {
    treatmentCategories,
    isNewBrandPageFeatureEnabled: envConfigSelectors.selectIsNewBrandPageFeatureEnabled(state),
  };
};

const mapDispatchToProps = {
  dispatchLoadTreatmentCategories: treatmentCategoriesActions.loadTreatmentCategories,
};

export const ConnectedTreatmentsSection = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentCategoriesSection);

TreatmentCategoriesSection.propTypes = {
  treatmentCategories: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      thumbnailImg: string.isRequired,
    }),
  ).isRequired,
  title: string,
  description: string,
  isNewBrandPageFeatureEnabled: bool.isRequired,

  dispatchLoadTreatmentCategories: func.isRequired,
};

TreatmentCategoriesSection.defaultProps = {
  title: 'Browse categories',
  description:
    "You'll find an impressive range of beauty services in the Beauty departments found in most of our shops. You'll be able to book many of those services here; for others, please call or ask in store.",
};
